import { Flex, Modal, Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../../util/hooks";
import { ColumnsType } from "antd/lib/table";
import { RelatorioLancamentoFinanceiroModel } from "../../../../../models/relatorio/relatorioLancamentoFinanceiroModel";
import { currencyBRL } from "../../../../../util/dinheiroBRAuxiliar";
import { newFormatPorcentagem } from "../../../../../util/formats";
import TableComponent from "../../../../../components/table/tableComponent";
import { BuscarRelatorioLancamentoFinanceiroDrillModel } from "../../../../../models/relatorio/buscarRelatorioLancamentoFinanceiroDrillModel";
import { buscarRelatorioLancamentoFinanceiroDrill } from "../../../../../services/relatorioService";
import { setModalRelatorioLancamentoFinanceiro } from "../../../../../redux/slices/relatorio/relatorioSlice";
import dayjs from "dayjs";
import { EmpresaModel } from "../../../../../models/empresa/empresaModel";

dayjs.locale("pt-br");

const RelatorioLancamentoPlanoConta = () => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);

  //hooks
  const dispatch = useAppDispatch();

  const goDetalhe = (value: RelatorioLancamentoFinanceiroModel) => {
    let busca: BuscarRelatorioLancamentoFinanceiroDrillModel = {
      ...relatorioState.buscaLancamentoFinanceiro,
      idHierarquia: value.id < 0 ? value.listaIdLancamento || "" : value.id.toString(),
      tipoHierarquia: value.id < 0 ? "TRANSF" : "PLAN_CT_FIN",
    };

    dispatch(buscarRelatorioLancamentoFinanceiroDrill(busca));
    dispatch(setModalRelatorioLancamentoFinanceiro(true));
  };

  const somatorio = relatorioState.listLancamentoFinanceiro
    .filter((conta) => ["01", "02", "03"].includes(conta.codigo))
    .reduce(
      (acumulador, conta) => {
        acumulador.valor += conta.valor || 0;
        return acumulador;
      },
      {
        valor: 0,
      }
    );

  const columns: ColumnsType<RelatorioLancamentoFinanceiroModel> = [
    {
      title: "DESCRIÇÃO",
      dataIndex: ["codigo", "denominacao", "nivel"],
      render: (_, record) => <div style={{ padding: `2px ${(record.nivel - 1) * 10}px` }}>{`${record.codigo} ${record.denominacao}`}</div>,
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "right",
      width: 200,
      render: (_, record) =>
        record.valor < 0 ? <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(record.valor)}</p> : <p style={{ marginBottom: "0px", color: "blue" }}>{currencyBRL(record.valor)}</p>,
    },
    {
      title: "PERCENTUAL",
      dataIndex: "percentual",
      align: "right",
      render: (_, record) =>
        record.valor < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{record.percentual && newFormatPorcentagem(record.percentual, 4)}</p>
        ) : (
          <p style={{ marginBottom: "0px", color: "blue" }}>{record.percentual && newFormatPorcentagem(record.percentual, 4)}</p>
        ),
    },
    {
      title: "PERCENTUAL DO RENDIMENTO",
      dataIndex: "percentualReceita",
      align: "right",
      render: (_, record) =>
        record.valor < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{record.percentualReceita && newFormatPorcentagem(record.percentualReceita, 4)}</p>
        ) : (
          <p style={{ marginBottom: "0px", color: "blue" }}>{record.percentualReceita && newFormatPorcentagem(record.percentualReceita, 4)}</p>
        ),
    },
  ];

  return (
    <Flex vertical>
      <TableComponent
        columns={columns}
        data={relatorioState.listLancamentoFinanceiro}
        loading={relatorioState.loadingLancamentoFinanceiro}
        pagination={false}
        tableProps={{
          onRow: (record: RelatorioLancamentoFinanceiroModel) => ({
            onClick: () => goDetalhe(record),
          }),
          className: "tableCentroCusto",
          summary: (pageData: any) =>
            pageData.length > 0 && (
              <Table.Summary.Row className="rowFooterCls">
                <Table.Summary.Cell index={0}>TOTAL:</Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <span style={{ color: somatorio.valor > 0 ? "blue" : "red", marginBottom: "0px" }}>{currencyBRL(somatorio.valor)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3}></Table.Summary.Cell>
              </Table.Summary.Row>
            ),
        }}
      />
    </Flex>
  );
};

export default RelatorioLancamentoPlanoConta;
